import { Inputs } from '../../../types';
import { TProjectConfigurationParameter } from '../../../../../entries/common/widgets/project-configuration/context';

export const getProjectConfigurationParameters = (
  inputsData: Inputs
): Array<TProjectConfigurationParameter> => {
  let projectConfigurationParameters = [];

  if (inputsData.doorType && inputsData.doorType.length > 0) {
    projectConfigurationParameters.push({
      key: 'doorType',
      value: inputsData.doorType.join(','),
    });
  }

  if (inputsData.colour && inputsData.colour.length > 0) {
    projectConfigurationParameters.push({
      key: 'colour',
      value: inputsData.colour.join(','),
    });
  }

  if (Boolean(inputsData.forWetRooms)) {
    projectConfigurationParameters.push({
      key: 'forWetRooms',
      value: inputsData.forWetRooms!,
    });
  }

  return projectConfigurationParameters;
};
